import React, { useState, useEffect } from "react";
import Navbar from "../components/Layout/Navbar";
import Footer from "../components/Layout/Footer";
import addImage from "../images/sbmt-1.png";
import { Form, Row, Col, Alert, Spinner } from "react-bootstrap";
import { OpenDay } from "../components/OpenDay";
import CustomHelmet from "../components/CustomHelmet";
import { Typeahead } from "react-bootstrap-typeahead";
import findStateByCountry from "../components/constants/findStateByCountry";
import countries2 from "../components/constants/countries2";
import axios from "axios";
import "react-bootstrap-typeahead/css/Typeahead.css";
import SearchLocationInput from "../components/SearchLocationInput";
import Fade from "react-reveal/Fade";
// import { Link } from "react-router-dom";
const urlEdit =
  "https://www.hubsquares.com/php_files/Edit-listing.php/";
const urlGetListing =
  "https://www.hubsquares.com/php_files/viewListing.php/";
const urlBusinessHour =
  "https://www.hubsquares.com/php_files/getBusinessHour.php/";
const urlGallery =
  "https://www.hubsquares.com/php_files/fetchGallery.php/";
export default function AddListing(props) {
  const [openDays, setOpenDays] = useState([]);
  const [day, setDay] = useState("Monday");
  const [days, setDays] = useState([]);
  const [spin, setSpin] = useState(false);
  const [start_time, setStart_time] = useState([]);
  const [end_time, setEnd_time] = useState([]);
  const [startTime, setStartTime] = useState("09:00");
  const [endTime, setEndTime] = useState("17:00");
  const [fullHour, setFullHour] = useState(false);
  const [multiple] = useState(false);
  const byGoogle = true;
  const [manual, setManual] = useState(false);
  const [address, setAddress] = useState("");
  const [lat, setLat] = useState("");
  const [lng, setLng] = useState("");
  const [title, setTitle] = useState("");
  const [tag, setTag] = useState("");
  const [country, setCountry] = useState([]);
  const [state, setState] = useState([]);
  const [phone, setPhone] = useState("");
  const [category, setCategory] = useState("");
  const [website, setWebsite] = useState("");
  const [whatsapp, setWhatsapp] = useState("");
  const [twitter, setTwitter] = useState("");
  const [facebook, setFacebook] = useState("");
  const [youtube, setYoutube] = useState("");
  const [google, setGoogle] = useState("");
  const [instagram, setInstagram] = useState("");
  const [linkedin, setLinkedin] = useState("");
  const [logo, setLogo] = useState(null);
  const [cover, setCover] = useState(null);
  const [gallery1, setGallery1] = useState(null);
  const [gallery2, setGallery2] = useState(null);
  const [gallery3, setGallery3] = useState(null);
  const [gallery4, setGallery4] = useState(null);
  const [gallery5, setGallery5] = useState(null);
  const [description, setDescription] = useState("");
  const [error, setError] = useState(false);
  const [errorValue, setErrorValue] = useState("");
  const [plan, setPlan] = useState("");
  const [ppackage, setPackage] = useState("");
  const [success, setSuccess] = useState(false);
  const [countries, setCountries] = useState([]);
  const [uploadedCover, setUploadedCover] = useState("");
  const [uploadedLogo, setUploadedLogo] = useState("");
  const [uploadedAddress, setUploadedAddress] = useState("");
  const [uploadedGallery1, setUploadedGallery1] = useState("");
  const [uploadedGallery2, setUploadedGallery2] = useState("");
  const [uploadedGallery3, setUploadedGallery3] = useState("");
  const [uploadedGallery4, setUploadedGallery4] = useState("");
  const [uploadedGallery5, setUploadedGallery5] = useState("");
  const [status,setStatus] = useState("")
  const business = [
    "Food and drinks Hub",
    "Catering and Restaurants Hub",
    "Hair products and Hair styling Hub",
    "Makeup and Skincare Hub",
    "Automobile Services",
    "Photography Hub",
    "Fabrics and Tailoring Hub",
    "Courier services Hub",
    "Event planners Hub",
    "Educational Services Hub",
    "Art and Crafts Hub",
    "Books and Authors Hub",
    "Property and Accommodation Hub",
    "Laundry and Cleaning Services Hub",
    "Fashion and Accessories Hub",
    "Tech and Electronics Hub",
    "Health and fitness Hub",
    "Home and decor Hub",
    "Gifting and personal shopping Hub",
    "Legal Services Hub",
    "Accounting Services Hub",
  ];

  // handleAddress(add) {
  //   setState({ address: add });
  // }
  useEffect(() => {
    let days = [];
    let start_time = [];
    let end_time = [];

    openDays &&
      openDays.forEach((item) => {
        days.push(item.days);
        start_time.push(item.start_time);
        end_time.push(item.end_time);
      });
    setDays(days);
    setStart_time(start_time);
    setEnd_time(end_time);
  }, [openDays]);
  useEffect(() => {
    if (props.match.params) {
      const fetchListing = () => {
        axios
          .post(urlGetListing, { refID: props.match.params.business })
          .then((res) => {
            let details = res.data.listing[0];
            setCountry([details.country]);
            setStatus(details.status);
            setLat(details.lat);
            setLng(details.lng);
            setTitle(details.title);
            setTag(details.tag);
            setState([details.state]);
            setPhone(details.phone);
            setLinkedin(details.linkedin);
            setWebsite(details.website);
            setWhatsapp(details.whatsapp);
            setInstagram(details.instagram);
            setCategory(details.category);
            setDescription(details.description);
            setTwitter(details.twitter);
            setFacebook(details.facebook);
            setGoogle(details.google);
            setYoutube(details.youtube);
            setPackage(details.package);
            setPlan(details.package);
            setUploadedCover(details.cover);
            setCover(details.cover);
            setUploadedLogo(details.logo);
            setLogo(details.logo);
            setUploadedAddress(details.googleaddress);
          });
        axios
          .post(urlBusinessHour, { refID: props.match.params.business })
          .then((res) => {
            setOpenDays(res.data.hours);
          });
        axios
          .post(urlGallery, { refID: props.match.params.business })
          .then((res) => {
            if (res.data.galleries) {
              setUploadedGallery1(res.data.galleries[0].gallery1);
              setGallery1(res.data.galleries[0].gallery1);
              setUploadedGallery2(res.data.galleries[0].gallery2);
              setGallery2(res.data.galleries[0].gallery2);
              setUploadedGallery3(res.data.galleries[0].gallery3);
              setGallery3(res.data.galleries[0].gallery3);
              setUploadedGallery4(res.data.galleries[0].gallery4);
              setGallery4(res.data.galleries[0].gallery4);
              setUploadedGallery5(res.data.galleries[0].gallery5);
              setGallery5(res.data.galleries[0].gallery5);
            }
          });
      };
      fetchListing();
    }
  }, [props.match.params]);

  function onDayRemove(id) {
    let newOpenDays = openDays.filter((day) => id !== day.day);
    setOpenDays(newOpenDays);
  }
  function handleDay(e) {
    setDay(e.target.value);
  }
  useEffect(() => {
    let newArray = [];
    countries2.forEach((i) => newArray.push(i.label));
    setCountries(newArray);
  }, []);
  const allState = country ? findStateByCountry(country[0]) : [""];

  function handleDaySubmit() {
    let prevDays = [...openDays];
    let newDays = [];
    if (fullHour === true)
      newDays = [
        ...prevDays,
        { days: day, start_time: "", end_time: "24 hours" },
      ];
    else
      newDays = [
        ...prevDays,
        {
          days: day,
          start_time: startTime,
          end_time: endTime,
        },
      ];
    let days = [];
    let start_time = [];
    let end_time = [];

    newDays.forEach((item) => {
      days.push(item.days);
      start_time.push(item.start_time);
      end_time.push(item.end_time);
    });
    setOpenDays(newDays);
    setDays(days);
    setStart_time(start_time);
    setEnd_time(end_time);
  }
  async function handlePayment() {
    setSpin(true);
    const formData = new FormData();
    if (address) formData.append("googleaddress", address);
    else formData.append("googleaddress", uploadedAddress);
    formData.append("cover", cover);
    formData.append("gallery1", gallery1);
    formData.append("gallery2", gallery2);
    formData.append("gallery3", gallery3);
    formData.append("gallery4", gallery4);
    formData.append("gallery5", gallery5);
    formData.append("owner", localStorage.getItem("access_token"));
    formData.append("title", title);
    formData.append("refID", props.match.params.business);
    formData.append("tag", tag);
    formData.append("package", ppackage);
    formData.append("country", country[0]);
    formData.append("state", state[0]);
    formData.append("phone", phone);
    formData.append("lng", lng);
    formData.append("lat", lat);
    formData.append("description", description);
    formData.append("website", website);
    formData.append("whatsapp", whatsapp);
    formData.append("category", category);
    formData.append("twitter", twitter);
    formData.append("facebook", facebook);
    formData.append("instagram", instagram);
    formData.append("linkedin", linkedin);
    formData.append("google", google);
    formData.append("day", days);
    formData.append("start_time", start_time);
    formData.append("end_time", end_time);
    formData.append("logo", logo);
    formData.append("status", status);
    await axios
      .post(urlEdit, formData, {
        headers: {
          "content-type": "multipart/form-data",
        },
      })
      .then(({ data }) => {
        if (data.success === 1) {
          setSuccess(true);
          console.log(data.msg);
          setErrorValue(
            "Your Business has been successfully created and will be approved within 3 working days. Thank you!"
          );
          setError(false);
          setSpin(true);
          props.history.push("/my-listings");
        } else if (data.success === 0) {
          console.log(data.msg);
          setErrorValue(data.msg);
          setError(true);
          setSuccess(false);
          setSpin(false);
        }
      });
  }

  useEffect(() => {
    if (error) {
      setTimeout(() => {
        setError(false);
        setErrorValue("");
      }, 5000);
    }
  }, [error]);

  return (
    <div>
      <CustomHelmet page="Edit Business" />
      <Navbar user={props.user} />
      <div className="wrapper add_banner position-relative">
        <div className="overlay">
          <div className="banner">
            <div className=" text-center mt-6 container">
              <h1>EDIT BUSINESS</h1>
            </div>
          </div>
        </div>
      </div>

      <main>
        <form>
          <div className="container my-5">
            <h3>Edit your Business</h3>

            <div className="row px-3">
              <div className="col-md-6" id="error">
                <div className="mb-5">
                  <Form.Group>
                    <h4>
                      Subscription Package Plan{" "}
                      <span className="text-red">*</span>
                    </h4>
                    <Form.Control as="select" value={plan} disabled>
                      <option value={ppackage}>{ppackage}</option>
                    </Form.Control>
                  </Form.Group>
                </div>
                <div className="mb-5">
                  <h4>
                    Business Title <span className="text-red">*</span>
                  </h4>
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control form-control-lg"
                      placeholder="Klinsheet Consulting Limited"
                      value={title}
                      onChange={(e) => setTitle(e.target.value)}
                    />
                  </div>
                  <div className="form-group">
                    <h4>
                      Business Tag <span className="text-red">*</span>
                    </h4>
                    <input
                      type="text"
                      className="form-control form-control-lg"
                      placeholder="Tag Line Example: No.1 Background Check Services Company"
                      value={tag}
                      onChange={(e) => setTag(e.target.value)}
                    />
                  </div>
                </div>
                <div className="mb-5">
                  <h4>
                    Country <span className="text-red">*</span>
                  </h4>

                  <Typeahead
                    id="basic-typeahead-example"
                    labelKey="name"
                    onChange={setCountry}
                    multiple={multiple}
                    options={countries}
                    placeholder="Choose a country..."
                    selected={country}
                  />
                </div>
                <div className="mb-5">
                  <h4>
                    State <span className="text-red">*</span>
                  </h4>
                  <Typeahead
                    id="basic-typeahead-example"
                    labelKey="name"
                    onChange={setState}
                    multiple={multiple}
                    options={allState}
                    placeholder="Choose a state..."
                    selected={state}
                  />
                </div>
                <div className="mb-5">
                  <h4>
                    Phone <span className="text-red">*</span>
                  </h4>
                  <div className="form-group">
                    <input
                      value={phone}
                      onChange={(e) => setPhone(e.target.value)}
                      type="text"
                      className="form-control form-control-lg"
                      placeholder="111-222-1111"
                    />
                  </div>
                </div>
                <div className="mb-5">
                  <h4>
                    Email <span className="text-red">*</span>
                  </h4>
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control form-control-lg"
                      placeholder="Email"
                      value={linkedin}
                      onChange={(e) => setLinkedin(e.target.value)}
                    />
                  </div>
                </div>
                <div className="mb-5">
                  <h4>Website</h4>
                  <div className="form-group">
                    <input
                      value={website}
                      onChange={(e) => setWebsite(e.target.value)}
                      type="text"
                      className="form-control form-control-lg"
                      placeholder="http://"
                    />
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-5">
                  <div className="row my-4">
                    <span
                      onClick={() => {
                        setManual(false);
                        console.log(title, tag, state[0], country[0], days);
                      }}
                      className="btn btn-warning text-white mr-2"
                    >
                      Search by Google
                    </span>
                  </div>
                  <div className="mb-5">
                    <h4>
                      Postal code /Zip code (Geolocation){" "}
                      <span className="text-red">*</span>
                    </h4>
                    <p>
                      current google address::{" "}
                      {uploadedAddress ? uploadedAddress : "empty"}
                    </p>
                    {byGoogle && (
                      <div className="form-group">
                        <SearchLocationInput
                          address={address}
                          setAddress={setAddress}
                          setLng={setLng}
                          setLat={setLat}
                        />
                      </div>
                    )}

                    {manual && (
                      <div className="form-group">
                        <input
                          type="text"
                          className="form-control form-control-lg"
                          placeholder="Enter Address"
                        />
                        <div className="row my-3">
                          <div className="col-6">
                            <input
                              type="text"
                              className="form-control form-control-lg"
                              placeholder="lng e.g 36.8233"
                            />
                          </div>
                          <div className="col-6">
                            <input
                              type="text"
                              className="form-control form-control-lg"
                              placeholder="lat e.g -1.2884"
                            />
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="mb-5">
                    <h4>Whatsapp</h4>
                    <p className="text-red">
                      Note: Number should include country code (e.g 2348088899,
                      447400000000) and DO NOT include "+"
                    </p>
                    <div className="form-group">
                      <input
                        value={whatsapp}
                        onChange={(e) => setWhatsapp(e.target.value)}
                        type="text"
                        className="form-control form-control-lg"
                        placeholder="44499498564"
                      />
                    </div>
                  </div>
                </div>

                <div className="py-5 d-flex justify-content-center align-items-center">
                  <img src={addImage} width="100%" alt="" />
                </div>
              </div>
            </div>
          </div>

          <div className="jumbotron">
            <div className="row">
              <div className="col-md-6">
                <h4>Add Business Hours</h4>
                <div className="open-week">
                  {openDays &&
                    openDays.map((day, i) => (
                      <div key={i}>
                        <OpenDay
                          day={day.days}
                          onRemove={() => onDayRemove(day.days)}
                          close={day.start_time}
                          open={day.end_time}
                        />
                      </div>
                    ))}
                  <div>
                    <Row>
                      <Col md={4}>
                        <Form.Control
                          as="select"
                          value={day}
                          onChange={(e) => handleDay(e)}
                        >
                          <option value="">Day</option>
                          <option value="Monday">Monday</option>
                          <option value="Tuesday">Tuesday</option>
                          <option value="Wednesday">Wednesday</option>
                          <option value="Thursday">Thursday</option>
                          <option value="Friday">Friday</option>
                          <option value="Saturday">Saturday</option>
                          <option value="Sunday">Sunday</option>
                        </Form.Control>
                      </Col>
                      <Col md={4}>
                        <Form.Control
                          as="select"
                          value={startTime}
                          onChange={(e) => setStartTime(e.target.value)}
                          disabled={fullHour}
                        >
                          <option value="00:00">00:00 </option>
                          <option value="00:30">00:30 </option>
                          <option value="01:30">01:30</option>
                          <option value="02:00">02:00</option>
                          <option value="02:30">02:30</option>
                          <option value="03:00">03:00</option>
                          <option value="03:30">03:30</option>
                          <option value="04:00">04:00</option>
                          <option value="04:30">04:30</option>
                          <option value="05:00">05:00</option>
                          <option value="05:30">05:30</option>
                          <option value="06:00">06:00</option>
                          <option value="06:30">06:30</option>
                          <option value="07:00">07:00</option>
                          <option value="07:30">07:30</option>
                          <option value="08:00">08:00</option>
                          <option value="08:30">08:30</option>
                          <option value="09:00">09:00</option>
                          <option value="09:30">09:30</option>
                          <option value="10:00">10:00</option>
                          <option value="10:30">10:30</option>
                          <option value="11:00">11:00</option>
                          <option value="11:30">11:30</option>
                          <option value="12:00">12:00</option>
                          <option value="12:30">12:30</option>
                          <option value="13:00">13:00</option>
                          <option value="13:30">13:30</option>
                          <option value="14:00">14:00</option>
                          <option value="14:30">14:30</option>
                          <option value="15:00">15:00</option>
                          <option value="15:30">15:30</option>
                          <option value="16:00">16:00</option>
                          <option value="16:30">16:30</option>
                          <option value="17:00">17:00</option>
                          <option value="17:30">17:30</option>
                          <option value="18:00">18:00</option>
                          <option value="18:30">18:30</option>
                          <option value="19:00">19:00</option>
                          <option value="19:30">19:30</option>
                          <option value="20:00">20:00</option>
                          <option value="20:30">20:30</option>
                          <option value="21:00">21:00</option>
                          <option value="21:30">21:30</option>
                          <option value="22:00">22:00</option>
                          <option value="22:30">22:30</option>
                          <option value="23:00">23:00</option>
                          <option value="23:30">23:30</option>
                        </Form.Control>
                      </Col>
                      <Col md={4}>
                        <Form.Control
                          as="select"
                          value={endTime}
                          onChange={(e) => setEndTime(e.target.value)}
                          disabled={fullHour}
                        >
                          <option value="00:00">00:00 </option>
                          <option value="00:30">00:30 </option>
                          <option value="01:30">01:30</option>
                          <option value="02:00">02:00</option>
                          <option value="02:30">02:30</option>
                          <option value="03:00">03:00</option>
                          <option value="03:30">03:30</option>
                          <option value="04:00">04:00</option>
                          <option value="04:30">04:30</option>
                          <option value="05:00">05:00</option>
                          <option value="05:30">05:30</option>
                          <option value="06:00">06:00</option>
                          <option value="06:30">06:30</option>
                          <option value="07:00">07:00</option>
                          <option value="07:30">07:30</option>
                          <option value="08:00">08:00</option>
                          <option value="08:30">08:30</option>
                          <option value="09:00">09:00</option>
                          <option value="09:30">09:30</option>
                          <option value="10:00">10:00</option>
                          <option value="10:30">10:30</option>
                          <option value="11:00">11:00</option>
                          <option value="11:30">11:30</option>
                          <option value="12:00">12:00</option>
                          <option value="12:30">12:30</option>
                          <option value="13:00">13:00</option>
                          <option value="13:30">13:30</option>
                          <option value="14:00">14:00</option>
                          <option value="14:30">14:30</option>
                          <option value="15:00">15:00</option>
                          <option value="15:30">15:30</option>
                          <option value="16:00">16:00</option>
                          <option value="16:30">16:30</option>
                          <option value="17:00">17:00</option>
                          <option value="17:30">17:30</option>
                          <option value="18:00">18:00</option>
                          <option value="18:30">18:30</option>
                          <option value="19:00">19:00</option>
                          <option value="19:30">19:30</option>
                          <option value="20:00">20:00</option>
                          <option value="20:30">20:30</option>
                          <option value="21:00">21:00</option>
                          <option value="21:30">21:30</option>
                          <option value="22:00">22:00</option>
                          <option value="22:30">22:30</option>
                          <option value="23:00">23:00</option>
                          <option value="23:30">23:30</option>
                        </Form.Control>
                      </Col>
                    </Row>
                    <div className="d-flex justify-content-between align-items-center my-2">
                      <Form.Group controlId="hourCheckBox">
                        <Form.Check
                          type="checkbox"
                          value={fullHour}
                          onChange={(e) => setFullHour(!fullHour)}
                          label="24 hours"
                        />
                      </Form.Group>
                      <span
                        className="btn btn-success"
                        onClick={(e) => handleDaySubmit(e)}
                      >
                        <i className="fa fa-plus"></i>
                      </span>
                    </div>
                  </div>
                </div>

                <h4 className="mt-5">
                  Category <span className="text-red">*</span>
                </h4>
                <div className="form-group mb-3">
                  <Form.Control
                    value={category}
                    onChange={(e) => setCategory(e.target.value)}
                    as="select"
                  >
                    <option>Choose Your Business Category</option>
                    {business
                      .sort((item1, item2) => (item1 > item2 ? 1 : -1))
                      .map((bus) => (
                        <option value={bus} key={bus}>
                          {bus}
                        </option>
                      ))}
                  </Form.Control>
                </div>
                <h4 className="mt-5">Upload Business Logo</h4>
                <p>current logo:: {uploadedLogo ? uploadedLogo : "empty"}</p>
                <input
                  accept=".jpg,.jpeg,.png"
                  name="logo"
                  onChange={(e) => {
                    setLogo(e.target.files[0]);
                  }}
                  type="file"
                  className="form-control"
                  id="customFile2"
                />
                <p className="muted">
                  Logo to upload should not be greater than 1mb
                </p>
                <h4 className="mt-4">
                  Upload Cover Image <span className="text-red">*</span>
                </h4>
                <p>
                  current cover image::{" "}
                  {uploadedCover ? uploadedCover : "empty"}
                </p>
                <input
                  accept=".jpg,.jpeg,.png"
                  name="cover"
                  type="file"
                  className="form-control"
                  placeholder="Username"
                  onChange={(e) => setCover(e.target.files[0])}
                />
                <p className="muted">
                  Cover to upload should not be greater than 1mb
                </p>
                <h4 className="mt-5">Add gallery</h4>
                <Row>
                  <Col md={6} className="mb-2">
                    <p>
                      current gallery 1 image::{" "}
                      {uploadedGallery1 ? uploadedGallery1 : "empty"}
                    </p>
                    <input
                      accept=".jpg,.jpeg,.png"
                      name="gallery1"
                      onChange={(e) => {
                        setGallery1(e.target.files[0]);
                      }}
                      type="file"
                      className="form-control"
                      id="customFile2"
                    />
                  </Col>
                  <Col md={6} className="mb-2">
                    <p>
                      current gallery 2 image::{" "}
                      {uploadedGallery2 ? uploadedGallery2 : "empty"}
                    </p>
                    <input
                      accept=".jpg,.jpeg,.png"
                      name="gallery2"
                      onChange={(e) => {
                        setGallery2(e.target.files[0]);
                      }}
                      type="file"
                      className="form-control"
                      id="customFile2"
                    />
                  </Col>
                  <Col md={6} className="mb-2">
                    <p>
                      current gallery 3 image::{" "}
                      {uploadedGallery3 ? uploadedGallery3 : "empty"}
                    </p>
                    <input
                      accept=".jpg,.jpeg,.png"
                      name="gallery3"
                      onChange={(e) => {
                        setGallery3(e.target.files[0]);
                      }}
                      type="file"
                      className="form-control"
                      id="customFile2"
                    />
                  </Col>
                  <Col md={6} className="mb-2">
                    <p>
                      current gallery 4 image::{" "}
                      {uploadedGallery4 ? uploadedGallery4 : "empty"}
                    </p>
                    <input
                      accept=".jpg,.jpeg,.png"
                      name="gallery4"
                      onChange={(e) => {
                        setGallery4(e.target.files[0]);
                      }}
                      type="file"
                      className="form-control"
                      id="customFile2"
                    />
                  </Col>
                  <Col md={6} className="mb-2">
                    <p>
                      current gallery 5 image::{" "}
                      {uploadedGallery5 ? uploadedGallery5 : "empty"}
                    </p>
                    <input
                      accept=".jpg,.jpeg,.png"
                      name="gallery5"
                      onChange={(e) => {
                        setGallery5(e.target.files[0]);
                      }}
                      type="file"
                      className="form-control"
                      id="customFile2"
                    />
                  </Col>
                </Row>
                <p className="muted">
                  Images to upload should not be greater than 1mb
                </p>
              </div>
              <div className="col-md-6">
                <h4>
                  Description <span className="text-red">*</span>
                </h4>
                <Form.Control
                  as="textarea"
                  value={description}
                  rows="5"
                  onChange={(e) => setDescription(e.target.value)}
                />
                <h5 className="mt-4">Social Media Links</h5>
                <p className="text-red">
                  copy and paste social media link( e.g.
                  http://www.instagram.com/hubsquares)
                </p>
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="text"
                        value={twitter}
                        onChange={(e) => setTwitter(e.target.value)}
                        className="form-control border-0 form-control-lg"
                        placeholder="Your Twitter URL"
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="text"
                        value={facebook}
                        onChange={(e) => setFacebook(e.target.value)}
                        className="form-control border-0 form-control-lg"
                        placeholder="Your Facebook URL"
                      />
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="text"
                        value={google}
                        onChange={(e) => setGoogle(e.target.value)}
                        className="form-control border-0 form-control-lg"
                        placeholder="Your Google Plus URL"
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="text"
                        value={instagram}
                        onChange={(e) => setInstagram(e.target.value)}
                        className="form-control border-0 form-control-lg"
                        placeholder="Your Instagram URL"
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="text"
                        value={youtube}
                        onChange={(e) => setYoutube(e.target.value)}
                        className="form-control border-0 form-control-lg"
                        placeholder="Your Youtube URL"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="container my-5">
            <span
              onClick={handlePayment}
              disabled={spin}
              className="btn border-0 my-3 auth-btn py-2 px-5 btn-danger btn-lg rad-0 addbtns"
            >
              Proceed
              {spin && (
                <Spinner
                  as="span"
                  animation="grow"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
              )}
              <i className="fal ml-2 fa-chevron-right"></i>
            </span>

            {error && (
              <Fade bottom collapse when={error}>
                <Alert variant="danger">{errorValue}</Alert>
              </Fade>
            )}
            {success && (
              <Fade bottom collapse when={success}>
                <Alert variant="success">{errorValue}</Alert>
              </Fade>
            )}
          </div>
        </form>
      </main>
      <Footer />
    </div>
  );
}
